import React, { useEffect, useRef, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import {
  Send2FAEmailOTP,
  Verify2FAEmailOTP,
} from "../../services/ReduxTookit/Slice/AuthFlowRedux";
import { toast } from "react-toastify";
import { GetByPrimarykey } from "../../services/ReduxTookit/Slice/UserRedux";
import { userInfo } from "../../services/ReduxTookit/UserInfoSlice";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import SubmitLoadingSmall from "../../component/common-component/Loaders/SubmitLoadingSmall";
import MainpageLoader from "../../component/common-component/Loaders/MainpageLoader";

const VerifyEmailOTP = ({ uid, setProceedData }) => {
  const [counter, setCounter] = useState(false);

  const [sendOtpStatus, setSendOtpStatus] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const dispatch = useDispatch();
  const inputRefs = {
    Number1: useRef(),
    Number2: useRef(),
    Number3: useRef(),
    Number4: useRef(),
    Number5: useRef(),
    Number6: useRef(),
  };
  const [otpTimer, setOtpTimer] = useState(0);
  useEffect(() => {
    if (otpTimer > 0) {
      const timer = setInterval(() => {
        setOtpTimer(otpTimer - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [otpTimer]);
  const [input, setInput] = useState({
    Number1: "",
    Number2: "",
    Number3: "",
    Number4: "",
    Number5: "",
    Number6: "",
    errors: {
      Number1: "",
      Number2: "",
      Number3: "",
      Number4: "",
      Number5: "",
      Number6: "",
      ValidationRules: [
        {
          FieldName: "Number1",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number2",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number3",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number4",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number5",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number6",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const handleInputChange = (e, inputName) => {
    fnInputChange(e.target.value, inputName); //added at 6-12-24
    const value = e.target.value;
    // if (/^[0-9]?$/.test(value)) {
    // setInput({ ...input, [inputName]: value }); //comment at 6-12-24
    if (value !== "" && inputName !== "Number6") {
      inputRefs[inputName]?.current?.blur();
      const nextInputName = `Number${
        parseInt(inputName.replace("Number", "")) + 1
      }`;
      inputRefs[nextInputName]?.current?.focus();
    }
  };
  const fnInputChange = (value, tag) => {
    if (value) {
      setInput({
        ...input,
        [tag]: value,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };
  const [Loading, setLoading] = useState(false);
  const [LoadingOTP, setLoadingOTP] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const handleEmailChange = (e) => {
    setUserEmail(e.target.value);
    if (emailError) {
      setEmailError(false);
    }
  };

  const handleKeyDown = (e, inputName) => {
    if (e.key === "Backspace") {
      if (e.target.value === "") {
        e.preventDefault();
        const currentIndex = parseInt(inputName.replace("Number", ""));
        if (currentIndex > 1) {
          const prevInputName = `Number${currentIndex - 1}`;
          inputRefs[prevInputName].current.focus();
        }
      }
    }
    if (e.key === "Enter" && e.target.value) {
      handleSubmit(e);
    }
  };
  const handlePaste = (event) => {
    const text = event.clipboardData.getData("text");

    let num1 = "",
      num2 = "",
      num3 = "",
      num4 = "",
      num5 = "",
      num6 = "";

    for (let i = 0; i < text?.length; i++) {
      if (i === 0) {
        num1 = text?.[i];
      } else if (i === 1) {
        num2 = text?.[i];
      } else if (i === 2) {
        num3 = text?.[i];
      } else if (i === 3) {
        num4 = text?.[i];
      } else if (i === 4) {
        num5 = text?.[i];
      } else if (i === 5) {
        num6 = text?.[i];
      }
    }

    setInput({
      ...input,
      Number1: num1,
      Number2: num2,
      Number3: num3,
      Number4: num4,
      Number5: num5,
      Number6: num6,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        userid: uid,
        otp:
          input.Number1 +
          input.Number2 +
          input.Number3 +
          input.Number4 +
          input.Number5 +
          input.Number6,
        email: userEmail,
        frompage: "2FA",
      };
      dispatch(Verify2FAEmailOTP(body)).then((response) => {
        if (response?.payload?.isValidate) {
          dispatch(GetByPrimarykey({})).then((response) => {
            if (response?.payload?.isValidate) {
              dispatch(userInfo(response?.payload?.data?.data));
            }
          });
        }
        if (!response?.payload?.isValidate) {
          setLoading(false);
        }
      });
    } else {
      toast.error("Please first verify your email and provide OTP");
    }
  };
  const validateEmail = (email) => {
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email);
  };
  // Add or remove 'loadtime' class based on MachineLoader

  useEffect(() => {
    if (LoadingOTP || Loading) {
      document.body.classList.add("loadtime");
    }
    // else {
    //   document.body.classList.remove('loadtime');
    // }

    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove("loadtime");
    };
  }, [LoadingOTP, Loading]); // Re-run this effect when MachineLoader changes

  return (
    <>
      {(Loading || LoadingOTP) && <MainpageLoader />}
      <div className="profile-common-title">
        <h3>Two-Factor Authentication</h3>
      </div>
      <div className="profile-common">
        <Form>
          <div className="authenticator-email">
            <div className="authenticator-email-detail">
              <h4>Email Authentication</h4>

              <p>
                Receive your 2FA verification code directly to your registered
                email address for added security during login.
              </p>
            </div>

            <Form.Group className="form-group">
              <Form.Label className="login-label">
                Email<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="input-type-pass">
                <Form.Control
                  // type={passwordVisible ? "text" : "password"}
                  placeholder="email address"
                  // className="login-input"
                  // maxLength={167}
                  value={userEmail}
                  // onChange={(e) => setUserEmail(e.target.value)}
                  onChange={handleEmailChange}
                  className={
                    emailError ? "is-invalid login-input" : "login-input"
                  }
                  // style={{ border: emailError && "1px solid red" }}
                  // isInvalid={input?.errors?.Password}
                />

                <button
                  disabled={sendOtpStatus}
                  className={"blue-btn"}
                  onClick={(e) => {
                    e.preventDefault();
                    if (userEmail) {
                      if (validateEmail(userEmail)) {
                        setEmailError(false);
                        setLoadingOTP(true);
                        dispatch(
                          Send2FAEmailOTP({
                            userid: uid,
                            email: userEmail,
                            frompage: "2FA",
                          })
                        )?.then((res) => {
                          setLoadingOTP(false);
                          if (res?.payload?.isValidate) {
                            setCounter(true);
                            setOtpTimer(60);
                            setSendOtpStatus(true);
                          }
                        });
                      } else {
                        toast.error("Please add valid email");
                        setEmailError(true);
                      }
                    } else {
                      toast.error("Please add valid email");
                      setEmailError(true);
                    }
                  }}
                >
                  {LoadingOTP ? (
                    // <>
                    //   <span>Loading</span>{" "}
                    //   <Spinner
                    //     className="ms-1"
                    //     animation="border"
                    //     role="status"
                    //     size="sm"
                    //   >
                    //     <span className="visually-hidden">Loading...</span>
                    //   </Spinner>
                    // </>

                    <SubmitLoadingSmall />
                  ) : (
                    "Send OTP"
                  )}
                </button>

                {counter ? (
                  <>
                    <div className="sendemail-verify">
                      <p>
                        We’ve sent you a 6 digit Security code to{" "}
                        <span style={{ color: "var(--blue2b)" }}>
                          {userEmail}
                        </span>
                        <br /> Please your code below
                      </p>
                    </div>

                    <Form.Group className="form-group mb-3 sendemail-verify-otp">
                      <Form.Label className="login-label">
                        OTP
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="mainotp-setup d-flex gap-3">
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              ref={inputRefs.Number1}
                              value={input.Number1}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => handleInputChange(e, "Number1")}
                              onKeyUp={(e) => handleKeyDown(e, "Number1")}
                              isInvalid={input?.errors?.Number1}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onPaste={handlePaste}
                            />
                          </div>
                        </div>
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              ref={inputRefs.Number2}
                              value={input.Number2}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => handleInputChange(e, "Number2")}
                              onKeyUp={(e) => handleKeyDown(e, "Number2")}
                              isInvalid={input?.errors?.Number2}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              ref={inputRefs.Number3}
                              value={input.Number3}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => handleInputChange(e, "Number3")}
                              onKeyUp={(e) => handleKeyDown(e, "Number3")}
                              isInvalid={input?.errors?.Number3}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              value={input.Number4}
                              ref={inputRefs.Number4}
                              onChange={(e) => handleInputChange(e, "Number4")}
                              onKeyUp={(e) => handleKeyDown(e, "Number4")}
                              onFocus={(e) => e.target.select()}
                              isInvalid={input?.errors?.Number4}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              value={input.Number5}
                              ref={inputRefs.Number5}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => handleInputChange(e, "Number5")}
                              onKeyUp={(e) => handleKeyDown(e, "Number5")}
                              isInvalid={input?.errors?.Number5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="otpset">
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              className="login-input text-center"
                              maxLength={1}
                              value={input.Number6}
                              ref={inputRefs.Number6}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => handleInputChange(e, "Number6")}
                              onKeyUp={(e) => handleKeyDown(e, "Number6")}
                              isInvalid={input?.errors?.Number6}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Form.Group>
                    {/* <div className="d-flex  mb-3 gap-3">
                      <div className="register-link-wrapper">
                        The OPT Will be Expire in{" "}
                        <span className="otptimerset">
                          {otpTimer === 60
                            ? "00:00"
                            : `00:${otpTimer < 10 ? `0${otpTimer}` : otpTimer}`}
                        </span>
                      </div>
                    </div> */}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Form.Group>
            <div className="popup-footer d-flex justify-content-end">
              <span
                className="grey-btn width150 text-center"
                onClick={(e) => {
                  setProceedData("");
                }}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </span>
              {counter && (
                <button
                  className="blue-btn width150 text-center"
                  onClick={(e) => handleSubmit(e)}
                  disabled={Loading}
                >
                  {Loading ? (
                    // <>
                    //   <span>Loading</span>{" "}
                    //   <Spinner
                    //     className="ms-1"
                    //     animation="border"
                    //     role="status"
                    //     size="sm"
                    //   >
                    //     <span className="visually-hidden">Loading...</span>
                    //   </Spinner>
                    // </>
                    <SubmitLoading />
                  ) : (
                    "Verify"
                  )}
                </button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default VerifyEmailOTP;
